export default {
  scheme: "https",
};



// WEBPACK FOOTER //
// ./src/config.js